import categories from '../actions/categories';

const initialState = {
    list: [],
    isFetching: false
};

export default (state = initialState, action) => {
    if (!action || !action.type) return state;
    switch (action.type) {
        case categories.actionTypes.RECEIVE_CATEGORY_LIST:
            return {
                ...state,
                list: action.payload,
                isFetching: false
            };
        case categories.actionTypes.REQUEST_CATEGORY_LIST:
            return { ...state, isFetching: true };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/reducers/categories.js